import {Injectable} from '@angular/core';
import {SwUpdate} from "@angular/service-worker";
import {Subscription} from "rxjs";
import {CacheService} from "./cache.service";
import {Router} from "@angular/router";

@Injectable({providedIn: 'root'})
export class PromptUpdateService {
    isNewVersionAvailable: boolean = false;
    newVersionSubscription: Subscription;
    constructor(
        private swUpdate: SwUpdate,
        private cacheService: CacheService,
        private router: Router
    ) {
        this.checkForUpdate();
    }
    checkForUpdate(): void {
        let me = this;
        this.newVersionSubscription?.unsubscribe();
        // console.log("PromptUpdateService:checkForUpdate()");
        this.newVersionSubscription = this.swUpdate.versionUpdates
            //.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY') )
            .subscribe(evt => {
                switch (evt.type) {
                    case 'VERSION_DETECTED':
                        console.log(`Downloading new app version: ${evt.version.hash}`);
                        break;
                    case 'VERSION_READY':
                        console.log(`Current app version: ${evt.currentVersion.hash}`);
                        console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                        me.cacheService.clearCacheAll();
                        me.forceReloadAndRegister();
                        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                        //     this.router.navigate([this.router.url]);
                        // });
                        break;
                    case 'VERSION_INSTALLATION_FAILED':
                        console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
                        break;
                    case 'NO_NEW_VERSION_DETECTED':
                        // console.log('No version detected');
                        break;
                }
                if ("latestVersion" in evt) {
                    console.log(`New app version ready for use: '${evt.latestVersion.hash}'`);
                }
            });
        if ( this.swUpdate.isEnabled ) {
            this.swUpdate.checkForUpdate();
        }
    }
    private forceReloadAndRegister(): void {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistration().then((registration) => {
                if (registration) {
                    registration.unregister().then(() => {
                        console.log('Service worker unregistered. Reloading page to force re-registration.');
                        document.location.reload();
                        // window.location.reload(true); // Force a hard reload, bypassing cache
                    });
                } else {
                    document.location.reload();
                    // window.location.reload(true);
                }
            });
        } else {
            document.location.reload();
            // window.location.reload(true);
        }
    }
}
